import { render, staticRenderFns } from "./CustomerOrthoIprs.vue?vue&type=template&id=2c71c110"
import script from "./CustomerOrthoIprs.vue?vue&type=script&lang=js"
export * from "./CustomerOrthoIprs.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrthoIprs.vue?vue&type=style&index=0&id=2c71c110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports